import mba_final_administration_icon from '../../assets/top_mba_colleges_in_india/mba_final_administration_icon.png'
import mba_full_time_icon from '../../assets/top_mba_colleges_in_india/mba_full_time_icon.png'
import mba_marketing_management_icon from '../../assets/top_mba_colleges_in_india/mba_marketing_management_icon.png'


export const institutesDetails = [

  {
    _id: "0",
    instituteName: "MBA (Full Time, 2Years)",
    instituteLink:
      "http://localhost:3000/Overview/66e946e39fd5e8df87e79553/mba-full-time-2years",
    instituteImage:
      mba_full_time_icon
  },
  {
    _id: "234",
    instituteName: "MBA (Marketing Management, 2Years)",
    instituteLink:
      "http://localhost:3000/Overview/66e950f99fd5e8df87e79620/mba-marketing-management-2years",
    instituteImage:
      mba_marketing_management_icon
  },
  {
    _id: "32",
    instituteName: "MBA (Financial Administration, 2Years)",
    instituteLink:
      "http://localhost:3000/Overview/66e956629fd5e8df87e796f8/mba-financial-administration-2years",

    instituteImage:
      mba_final_administration_icon
  },
];

export const faqs = [
  {
    id: "1",
    question: "Is CDGI among the top MBA colleges in Indore?",
    answer:
      "Yes. CDGI is NAAC A+ accredited, AICTE-approved, and offers strong placement support, making it one of the top MBA colleges in Indore.",
  },
  {
    id: "2",
    question: "What are the specializations offered in the MBA program?",
    answer:
      "We offer MBA in Marketing Management and MBA in Financial Administration.",
  },
  {
    id: "3",
    question: "Does CDGI offer placement support?",
    answer:
      "Yes. CDGI provides 100% placement assistance including internships, interview training, and recruiter access.",
  },
  {
    id: "4",
    question: "Is there a hostel facility available for MBA students?",
    answer:
      "Yes. CDGI offers well-maintained, Wi-Fi-enabled hostels with all modern amenities.",
  },
  {
    id: "5",
    question: "How do I apply for the MBA program at CDGI?",
    answer:
      "You can apply online through our official website https://www.cdgi.edu.in or contact the admission cell.",
  },
];

export const allCoursesForForm = [
  "Engineering Courses [CS, IT, AI & DS, CSIT]",
  "Engineering Course [Electronics & Comm. Engg.]",
  "Engineering Course [Mechanical Engineering]",
  "Engineering Course [Civil Engineering]",
  "Pharmacy Courses [B.Pharm, D.Pharm]",
  "Pharmacy Course [M.Pharm]",
  "Management Courses [MBA(FT,MM,FA)]",
  "Professional Courses [BBA]",
  "Professional Courses [BCA]",
  "Professional Courses [B.Com]",
  "Law Courses [LLB Hons, BA LLB Hons, BBA LLB Hons]",
  "MCA Course"
]

export const mbaHighlights = [
  "NAAC A+ Accreditation & AICTE Approval",
  "Industry-relevant Curriculum with Case-Based Learning",
  "Specializations in Marketing Management & Financial Administration",
  "100+ Corporate Recruiters",
  "Advanced Business Labs & Digital Classrooms",
  "Regular Industry Guest Sessions and Workshops",
  "Internship and Live Projects with Industry Leaders"
];
